<template>
  <div class="content-container">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>管理</el-breadcrumb-item>
      <el-breadcrumb-item>销售组管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel mt-20">
      <el-button
        type="primary"
        size="small"
        icon="el-icon-plus"
        @click="handleNew"
        v-permission="Auth.groupEdit"
        >新增销售组</el-button
      >
      <el-table v-if="!isMobile()" :data="lists" stripe style="width: 100%">
        <el-table-column prop="name" label="组名"></el-table-column>
        <el-table-column
          prop="leader.name"
          label="组长"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="manager.name"
          label="经理"
          align="center"
        ></el-table-column>
        <el-table-column label="成员">
          <template slot-scope="scope">{{ showMembers(scope.row) }}</template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="200">
          <template slot-scope="scope">
            <el-popconfirm
              class="mr-10"
              :title="'确认删除吗？'"
              @confirm="handleDelete(scope.$index, scope.row.id)"
              v-permission="Auth.groupDelete"
            >
              <el-button slot="reference" type="danger" plain size="mini"
                >删除</el-button
              >
            </el-popconfirm>
            <el-button
              type="primary"
              plain
              size="mini"
              @click="handleEdit(scope.$index, scope.row)"
              v-permission="Auth.groupEdit"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <ul v-else class="list-style">
        <li v-for="(group, index) in lists">
          <div>{{ group.name }}</div>
          <div class="text-info-12">组长：{{ group.leader.name }}</div>
          <div class="text-info-12">经理：{{ group.manager.name }}</div>
          <div class="text-info-12">成员：{{ showMembers(group) }}</div>
          <div class="mt-10">
            <el-popconfirm
              class="mr-10"
              :title="'确认删除吗？'"
              @confirm="handleDelete(index, group.id)"
              v-permission="Auth.groupDelete"
            >
              <el-button slot="reference" type="danger" plain size="mini"
                >删除</el-button
              >
            </el-popconfirm>
            <el-button
              type="primary"
              plain
              size="mini"
              @click="handleEdit(index, group)"
              v-permission="Auth.groupEdit"
              >编辑</el-button
            >
          </div>
        </li>
      </ul>
      <el-dialog
        :title="group.id ? '编辑组' : '新增组'"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        width="40%"
        @closed="resetForm('group')"
      >
        <el-form
          :model="group"
          :rules="rules"
          ref="group"
          size="small"
          label-width="90px"
        >
          <el-form-item label="组名" prop="name">
            <el-input v-model="group.name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="组长" prop="leader_id">
            <el-select
              v-model="group.leader_id"
              filterable
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="item in users"
                :key="item.id"
                :label="item.name"
                :value="parseInt(item.id)"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="经理" prop="manager_id">
            <el-select
              v-model="group.manager_id"
              filterable
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="item in users"
                :key="item.id"
                :label="item.name"
                :value="parseInt(item.id)"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="成员" prop="member_ids">
            <el-select
              v-model="group.member_ids"
              multiple
              filterable
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="item in users.filter(
                  (item) =>
                    item.group_id == 0 || group.member_ids.includes(item.id)
                )"
                :key="item.id"
                :label="item.name"
                :value="parseInt(item.id)"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="描述" prop="description">
            <el-input
              v-model="group.description"
              type="textarea"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false" size="small"
            >取 消</el-button
          >
          <el-button type="primary" @click="submitForm('group')" size="small"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  userList,
  groupList,
  createGroup,
  updateGroup,
  deleteGroup,
} from '@/service/getData'
import { clone } from '@/util'
import { isMobile } from '@/util/index'

export default {
  data() {
    return {
      page: 0,
      size: 20,
      users: [],
      group: {
        id: 0,
        name: '',
        description: '',
        leader_id: '',
        manager_id: '',
        member_ids: [],
      },
      isMobile,
      editIndex: 0,
      rules: {
        name: [
          { required: true, message: '请填写组名', trigger: 'blur' },
          {
            min: 2,
            max: 15,
            message: '长度在 2 到 15 个字符',
            trigger: 'blur',
          },
        ],
      },
      lists: [],
      dialogVisible: false,
    }
  },
  created() {
    this.initData()
  },
  methods: {
    async initData() {
      let res = await groupList({ page: this.page, size: this.size })
      if (res.code == 0) {
        this.lists = res.data.list
      }

      res = await userList({ page: 0, size: 1000 })
      if (res.code == 0) {
        this.users = res.data.list
      }
    },
    showMembers(group) {
      if (!group.members) return
      let members = group.members.map((item) => {
        return item.name
      })
      return members.join(' / ')
    },

    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.group.leader_id = parseInt(this.group.leader_id) || 0
          this.group.manager_id = parseInt(this.group.manager_id) || 0

          // if (
          //   this.group.leader_id != 0 &&
          //   !this.group.member_ids.includes(this.group.leader_id)
          // ) {
          //   this.group.member_ids.push(this.group.leader_id)
          // }

          // if (
          //   this.group.manager_id != 0 &&
          //   !this.group.member_ids.includes(this.group.manager_id)
          // ) {
          //   this.group.member_ids.push(this.group.manager_id)
          // }
          if (this.group.id) {
            let res = await updateGroup(this.group)
            if (res.code == 0) {
              this.$set(this.lists, this.editIndex, res.data)
              this.dialogVisible = false
            }
          } else {
            let res = await createGroup(this.group)
            if (res.code == 0) {
              this.lists.unshift(res.data)
              this.dialogVisible = false
            }
          }
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.group.id = 0
    },
    handleNew() {
      this.group = {
        id: 0,
        name: '',
        description: '',
        leader_id: '',
        manager_id: '',
        member_ids: [],
      }
      this.dialogVisible = true
    },
    handleEdit(index, item) {
      this.dialogVisible = true
      this.editIndex = index
      this.$nextTick(() => {
        let data = clone(item)
        data.member_ids = data.members.map((item) => {
          return item.id
        })
        if (data.leader_id == 0) data.leader_id = ''
        if (data.manager_id == 0) data.manager_id = ''
        this.group = data
      })
    },
    async handleDelete(index, id) {
      let res = await deleteGroup(id)
      if (res.code == 0) {
        this.lists.splice(index, 1)
      }
    },
  },
}
</script>

<style scoped>
.long {
  width: 100%;
}
</style>